const filename = fullPath => {
    if (!fullPath) {
        return "";
    }

    const slashIdx = fullPath.lastIndexOf("/");
    const bslashIdx = fullPath.lastIndexOf("\\");

    if (slashIdx === -1 && bslashIdx === -1) {
        return fullPath;
    }

    const idx = (slashIdx > bslashIdx ? slashIdx : bslashIdx) + 1;
    if (idx >= fullPath.length) {
        return fullPath;
    }

    return fullPath.substr(idx);
}

export {
    filename
}

export default {
    filename
}